import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const LoginLink = ({ children, isLoginModuleEnabled, redirectUrl, render }) => {
  if (isLoginModuleEnabled === true) {
    const url = `/login?redirect=${encodeURIComponent(redirectUrl)}`
    return render
      ? render(url)
      : <Link to={url}>{children}</Link>
  }
  if (isLoginModuleEnabled) {
    return render
      ? render(isLoginModuleEnabled, true)
      : (<a href={isLoginModuleEnabled}>{children}</a>)
  }
  return render
    ? render()
    : children
}

LoginLink.propTypes = {
  redirectUrl: PropTypes.string,
  children: PropTypes.node,
  isLoginModuleEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  render: PropTypes.func
}

LoginLink.defaultProps = {
  isLoginModuleEnabled: true
}

export default React.memo(LoginLink)
